import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { CompanyModel } from '../../../../model/company.model';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { properties } from '../../../../../environments/properties';
import { AppService } from '../../../../core/service/app.service';
import { DocumentDriverModel } from '../../../../model/document.driver.model';
import { DocumentVehicleModel } from '../../../../model/document.vehicle.model';
import { DriverVehicleResultModel } from '../../../../model/driver-vehicle-result.model';
import { compressImage } from '../../../../shared/utils/image-compression.util';
import { isAllowedUploadType } from '../../../../shared/utils/file-type-validator.util';
import { ImageModule } from 'primeng/image';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { RouterLink } from '@angular/router';
import { RadioButtonModule } from 'primeng/radiobutton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

interface UploadEvent {
  files: File[];
}

@Component({
  selector: 'app-create-driver',
  standalone: true,
  imports: [
    StepperModule,
    ButtonModule,
    InputTextModule,
    ToggleButtonModule,
    CommonModule,
    FormsModule,
    FloatLabelModule,
    ReactiveFormsModule,
    TableModule,
    FileUploadModule,
    ImageModule,
    DropdownModule,
    CheckboxModule,
    RouterLink,
    RadioButtonModule,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './create-driver.component.html',
  styleUrl: './create-driver.component.css',
})
export class CreateDriverComponent implements OnInit {
  titulo: string = 'Crear Conductor';
  step1_titulo: string = 'Datos del Conductor';
  step2_titulo: string = 'Datos de la Compañia';
  step3_titulo: string = 'Datos del Vehículo';
  step4_titulo: string = 'Documentos del Conductor';
  step5_titulo: string = 'Documentos del Vehículo';
  step6_titulo: string = 'Hecho';
  active: number = 0;
  selectCompany!: CompanyModel;
  ltsCompany!: CompanyModel[];
  ltsDocument: DocumentDriverModel[] = [];
  ltsTypeDocument: any[] = [];
  selectedTypeDocument: any | undefined;
  ltsDocumentVehicle: DocumentVehicleModel[] = [];
  ltsTypeDocumentVehicle: any[] = [];
  selectedTypeDocumentVehicle: any | undefined;
  vehicleConflict: boolean = false;
  createdVehicleId: number | null = null;
  resultMessage: string = '';
  loading: boolean = false;
  ingredient!: string;
  formConductor = new FormGroup({
    dri_name: new FormControl('', Validators.required),
    dri_last_name: new FormControl('', Validators.required),
    dri_number_license: new FormControl('', Validators.required),
    dri_term_conditions: new FormControl('', Validators.required),
    dri_social: new FormControl('', Validators.required),
    dri_phone: new FormControl('', Validators.required),
    dri_address: new FormControl('', Validators.required),
    dri_password: new FormControl('', Validators.required),
  });
  formVehiculo = new FormGroup({
    veh_plate: new FormControl('', Validators.required),
    veh_num_registration: new FormControl('', Validators.required),
    veh_model: new FormControl('', Validators.required),
    veh_brand: new FormControl('', Validators.required),
    veh_quantity_person: new FormControl('', Validators.required),
    veh_anio: new FormControl('', Validators.required),
    veh_color: new FormControl('', Validators.required),
    veh_inspection: new FormControl('', Validators.required),
    veh_secure: new FormControl('', Validators.required),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getLtsCompany();
    this.getLtsTypeDocument();
    this.getLtsTypeDocumentVehicle();
  }

  next(): void {
    if (this.active === 1) {
      if (this.selectCompany === null) {
      } else {
        this.active++;
      }
    } else {
      this.active++;
    }
  }

  back(): void {
    this.active--;
  }

  getLtsCompany(): void {
    const body: JsonRequest = {
      data: '',
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.loading = true;
    this.apiService.consumirWSPost(
      properties.serviceGetAllCompany,
      body,
      (data) => {
        this.ltsCompany = data.data;
        this.ltsCompany.forEach((item) => {
          item.estado = item.com_status == 1;
        });
        this.loading = false;
      },
    );
  }

  getLtsTypeDocument(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        typ_type_document: '1',
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.loading = true;
    this.apiService.consumirWSPost(
      properties.serviceGetAllTypeDocument,
      body,
      (data) => {
        this.ltsTypeDocument = data.data;
        this.selectedTypeDocument = this.ltsTypeDocument[0];
        this.loading = false;
      },
    );
  }

  getLtsTypeDocumentVehicle(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        typ_type_document: 2,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetAllTypeDocument,
      body,
      (data) => {
        this.ltsTypeDocumentVehicle = data.data;
        this.selectedTypeDocumentVehicle = this.ltsTypeDocumentVehicle[0];
      },
    );
  }

  backStart(): void {
    this.active = 0;
  }

  crearDriver(): void {
    let fotoPerfil = this.ltsDocument.filter(
      (item) => item.dri_doc_typ_codigo === 1,
    );
    if (fotoPerfil.length > 0) {
      const formData = new FormData();
      formData.append(
        'dri_name',
        this.formConductor.get('dri_name')?.value ?? '',
      );
      formData.append(
        'dri_last_name',
        this.formConductor.get('dri_last_name')?.value ?? '',
      );
      formData.append(
        'dri_number_license',
        this.formConductor.get('dri_number_license')?.value ?? '',
      );
      formData.append(
        'dri_term_conditions',
        this.formConductor.get('dri_term_conditions')?.value ?? '',
      );
      formData.append(
        'dri_social',
        this.formConductor.get('dri_social')?.value ?? '',
      );
      formData.append(
        'dri_phone',
        this.formConductor.get('dri_phone')?.value ?? '',
      );
      formData.append(
        'dri_address',
        this.formConductor.get('dri_address')?.value ?? '',
      );
      formData.append(
        'dri_password',
        this.formConductor.get('dri_password')?.value ?? '',
      );
      formData.append('dri_company', this.selectCompany.com_id.toString());

      formData.append(
        'veh_plate',
        this.formVehiculo.get('veh_plate')?.value ?? '',
      );
      formData.append(
        'veh_num_registration',
        this.formVehiculo.get('veh_num_registration')?.value ?? '',
      );
      formData.append(
        'veh_model',
        this.formVehiculo.get('veh_model')?.value ?? '',
      );
      formData.append(
        'veh_brand',
        this.formVehiculo.get('veh_brand')?.value ?? '',
      );
      formData.append(
        'veh_quantity_person',
        this.formVehiculo.get('veh_quantity_person')?.value ?? '',
      );
      formData.append(
        'veh_anio',
        this.formVehiculo.get('veh_anio')?.value ?? '',
      );
      formData.append(
        'veh_color',
        this.formVehiculo.get('veh_color')?.value ?? '',
      );
      formData.append(
        'veh_inspection',
        this.formVehiculo.get('veh_inspection')?.value == 'true' ? '1' : '0',
      );
      formData.append(
        'veh_secure',
        this.formVehiculo.get('veh_secure')?.value == 'true' ? '1' : '0',
      );

      fotoPerfil.forEach((doc, index) => {
        formData.append(`file`, doc.file, doc.file.name);
      });

      this.loading = true;
      this.apiService.consumirWSFilePost(
        properties.serviceCreateDriverWithVehicle,
        formData,
        (data) => {
          if (data.estado === properties.codeOK) {
            const result: DriverVehicleResultModel = data.data;
            this.vehicleConflict = result.vehicleConflict;
            this.createdVehicleId = result.vehicleId;
            this.resultMessage = result.message;

            const formDataDocs = new FormData();
            let documents = this.ltsDocument.filter(
              (item) => item.dri_doc_typ_codigo !== 1,
            );
            const continueFlow = () => {
              this.loading = false;
              this.formConductor.reset();
              this.formVehiculo.reset();
              this.ltsDocument = [];
              this.util.mostrarToast(
                'Crear Conductor',
                result.message,
                result.vehicleConflict ? 2 : 1,
              );
              // sin conflicto: avanza al step de documentos de vehículo;
              // con conflicto: no hay vehículo propio, salta directo a "Hecho"
              this.active = result.vehicleConflict ? 5 : 4;
            };

            if (documents.length > 0) {
              documents.forEach((doc, index) => {
                formDataDocs.append(
                  `lista[${index}][dri_doc_dri_id]`,
                  result.driver.dri_id.toString(),
                );
                formDataDocs.append(
                  `lista[${index}][dri_doc_typ_codigo]`,
                  doc.dri_doc_typ_codigo.toString(),
                );
                formDataDocs.append(
                  `lista[${index}].file`,
                  doc.file,
                  doc.file.name,
                );
              });

              this.apiService.consumirWSFilePost(
                properties.serviceFilesDriver,
                formDataDocs,
                (resp) => {
                  continueFlow();
                },
              );
            } else {
              continueFlow();
            }
          } else {
            this.loading = false;
            this.util.mostrarToast(
              'Crear Conductor',
              'Debe tener una foto de perfil',
              3,
            );
          }
        },
      );
    } else {
      this.util.mostrarToast(
        'Crear Conductor',
        'Debe tener una foto de perfil',
        3,
      );
    }
  }

  async onUploadAuto(files: File[], fileUpload: any) {
    if (!isAllowedUploadType(files[0], true)) {
      this.util.mostrarToast(
        'Crear Conductor',
        'Formato no permitido. Solo se aceptan imágenes PNG o JPG o documentos PDF.',
        4,
      );
      fileUpload.clear();
      return;
    }
    const doc = await compressImage(files[0]);
    const filestring = await this.previewFile(doc);
    this.ltsDocument.push({
      dri_doc_dri_id: 0,
      dri_doc_doc_id: 0,
      dri_doc_company: this.util.returnEmpresa(),
      dri_doc_typ_codigo: this.selectedTypeDocument.typ_type_document,
      file: doc,
      filstring: filestring,
      typeDocument: this.selectedTypeDocument,
    });
    fileUpload.clear();
  }

  removeFile(index: number) {
    this.ltsDocument.splice(index, 1);
  }

  async onUploadAutoVehicle(files: File[], fileUpload: any) {
    if (!isAllowedUploadType(files[0], true)) {
      this.util.mostrarToast(
        'Crear Conductor',
        'Formato no permitido. Solo se aceptan imágenes PNG o JPG o documentos PDF.',
        4,
      );
      fileUpload.clear();
      return;
    }
    const doc = await compressImage(files[0]);
    const filestring = await this.previewFile(doc);
    this.ltsDocumentVehicle.push({
      veh_doc_veh_id: 0,
      veh_doc_doc_id: 0,
      veh_doc_company: this.util.returnEmpresa(),
      veh_doc_typ_id: this.selectedTypeDocumentVehicle.typ_id,
      file: doc,
      filstring: filestring,
      typeDocument: this.selectedTypeDocumentVehicle,
    });
    fileUpload.clear();
  }

  removeFileVehicle(index: number) {
    this.ltsDocumentVehicle.splice(index, 1);
  }

  guardarDocumentosVehiculo(): void {
    if (this.ltsDocumentVehicle.length === 0 || this.createdVehicleId === null) {
      this.active = 5;
      return;
    }
    const formData = new FormData();
    this.ltsDocumentVehicle.forEach((doc, index) => {
      formData.append(
        `lista[${index}][veh_doc_veh_id]`,
        this.createdVehicleId!.toString(),
      );
      formData.append(
        `lista[${index}][veh_doc_company]`,
        this.util.returnEmpresa().toString(),
      );
      formData.append(
        `lista[${index}][veh_doc_typ_id]`,
        doc.veh_doc_typ_id.toString(),
      );
      formData.append(`lista[${index}].file`, doc.file, doc.file.name);
    });
    this.apiService.consumirWSFilePost(
      properties.serviceFilesVehicle,
      formData,
      (resp) => {
        this.ltsDocumentVehicle = [];
        this.active = 5;
        if (resp.estado !== properties.codeOK) {
          this.util.mostrarToast(
            'Documentos del vehículo',
            'No se pudieron subir todos los documentos',
            4,
          );
        }
      },
    );
  }

  previewFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Error al leer el archivo');
        }
      };
      reader.onerror = () => {};
    });
  }
}
